<template>
    <v-dialog
        v-model="show"
        @input="v => v || onModalClose()"
        width="500"
    >
        <v-card>
            <v-card-text>{{message}}</v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'Inform',
    data () {
        return {
            show: false,
            message: '',
            onClose: null
        }
    },
    methods: {
        onModalClose () {
            if (this.onClose) {
                this.onClose()
            }
        },
        open (message = '', options) {
            this.message = message
            if (options) {
                this.onClose = options.onClose
            }
            this.show = true
        },
        close () {
            this.show = false
        }
    }
}
</script>
